import { defineComponent as _defineComponent } from 'vue'
import { useAuth } from "@/store/auth/useAuth"
import MissionUpdates from "@/modules/Missions/components/MissionUpdates/MissionUpdates.vue"
import TasksWidget from "@/components/tasks/TasksWidget.vue"
import AppPage from "@/components/layout/AppPage.vue"
import { useQuery } from "@vue/apollo-composable"
import {
  StaffMissionUpdatesQuery,
  StaffMissionUpdatesQueryQuery,
  StaffMissionUpdatesQueryQueryVariables,
  MissionLifecycleState,
  SortDirection,
  MissionLifecycleBasic,
} from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffHome',
  setup(__props) {

const { user } = useAuth()

const { loading, result } = useQuery<
  StaffMissionUpdatesQueryQuery,
  StaffMissionUpdatesQueryQueryVariables
>(StaffMissionUpdatesQuery, {
  filter: {
    stateIn: [
      MissionLifecycleState.ExecutionStage,
      MissionLifecycleState.ProposalStage,
      MissionLifecycleState.ScopingStage,
    ],
  },
  per: 5,
  sort: {
    createdAt: SortDirection.Desc,
  },
})

const mapToMissionFragment = (mission: any): MissionLifecycleBasic => {
  const { __typename, ...rest } = mission
  return {
    ...rest,
    prn: mission.id, // Assuming id can be used as prn
  }
}

return { __sfc: true,user, loading, result, mapToMissionFragment, MissionUpdates, TasksWidget, AppPage }
}

})